import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { BreakpointObserverService } from '../../../../shared/services/breakpoint-observer.service';
import { MenuGroupType } from '../../../map.component';
import { AsyncPipe, NgIf } from '@angular/common';
import { LayersMenuComponent } from '../layers-menu/layers-menu.component';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { IconButtonDirective } from '../../../../shared/directives/icon-button.directive';
import { LayersMenuService } from '../layers-menu/layers-menu.service';
import { ModalService } from '../../../../shared/services/modal.service';

@Component({
  selector: 'app-map-menu',
  templateUrl: './map-menu.component.html',
  styleUrls: ['./map-menu.component.scss'],
  imports: [
    AsyncPipe,
    NgIf,
    LayersMenuComponent,
    IconComponent,
    IconButtonDirective,
  ],
})
export class MapMenuComponent implements OnInit {
  private modalService = inject(ModalService);
  public menuService = inject(LayersMenuService);
  public breakpointObserverService = inject(BreakpointObserverService);

  @Input() activeMenuGroup!: MenuGroupType;

  @Output() closeRightMenu = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}

  public handleHelpModal(): void {
    this.modalService.openHelpAndFeedbackModal();
  }

  public emitCloseMenuMobile(): void {
    this.closeRightMenu.emit();
  }
}
